import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import GET_WDT_STUDENT_SETTINGS from 'graph/settings/wdt/get-wdt-student-settings-query';
import GET_WDT_CLASSROOM_SETTINGS from 'graph/settings/wdt/get-wdt-classroom-settings-query';
import { Student } from 'types/schema-generated-types';
import LetterNumberOrder from './CharacterOrder';
import LeftHandedness from './LeftHandOption';

interface WdtSettingsProps {
  classroomId: number;
  student: Student;
  productCurriculumCode: string;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const StudentWdtSettings: FC<WdtSettingsProps> = ({
  student,
  classroomId,
  expanded,
  handleChangeExpanded
}) => {
  const { id: studentId } = student;
  const { data: classroomData, loading: classroomLoading } = useQuery(GET_WDT_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });
  const { data: studentData, loading: studentLoading } = useQuery(GET_WDT_STUDENT_SETTINGS, {
    variables: {
      where: {
        studentId: Number(studentId)
      }
    }
  });

  return (
    <PageContainer loading={classroomLoading || studentLoading}>
      <LetterNumberOrder
        student={student}
        setting={studentData?.wdtStudentSettings.characterOrder}
        classroomSetting={classroomData?.wdtClassroomSettings.characterOrder}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
      <LeftHandedness
        student={student}
        setting={studentData?.wdtStudentSettings.handedness}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default StudentWdtSettings;
